export default "static/media/talentmaker.88a131c.svg"